import {
  TherapistAction,
  addTaskConstant,
  editTaskConstant,
} from '../../../src/redux/actions/constant';
const { ADD_TASK_THERAPIST_REQUEST, ADD_TASK_THERAPIST_RESET } = addTaskConstant;
const { EDIT_TASK_THERAPIST_SCHEDULING_REQUEST, EDIT_TASK_THERAPIST_SCHEDULING_RESET } =
  editTaskConstant;

export const getAllTaskTypeAction = (payload: any) => {
  return {
    type: TherapistAction.GET_ALL_TASK_TYPE_REQUEST,
    payload,
  };
};

export const addTaskToTherapist = (payload: any) => {
  return {
    type: ADD_TASK_THERAPIST_REQUEST,
    payload,
  };
};

export const resetAddNewTaskTherapist = () => {
  return {
    type: ADD_TASK_THERAPIST_RESET,
  };
};

export const editTaskTherapistSchedulingAction = (payload: any) => {
  return {
    type: EDIT_TASK_THERAPIST_SCHEDULING_REQUEST,
    payload,
  };
};
export const editTaskTherapistSchedulingResetAction = () => {
  return {
    type: EDIT_TASK_THERAPIST_SCHEDULING_RESET,
  };
};
